import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'
import { colors } from '@/styles/theme'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 46px;
  overflow: hidden;
`

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
`

export const Range = styled.div`
  position: relative;
  height: 10px;
  flex-grow: 1;
  margin: 33px 10px;
  width: 90%;

  @media (min-width: 768px) {
    width: 80%;
  }

  @media (min-width: 1440px) {
    width: 90%;
  }
`

export const Track = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #c1c5c9;
  top: 50%;
  transform: translateY(-50%);
`

export const Highlight = styled.div`
  position: absolute;
  height: 2px;
  background-color: #093769;
  top: 50%;
  transform: translateY(-50%);
`

export const Thumb = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: ${colors.white};
  border: 2px solid #093769;
  border-radius: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`

export const ThumbLabel = styled.div<{ thumbPosition: number }>`
  position: absolute;
  top: -29px;
  transform: translateX(-50%);
  background-color: ${colors.white};
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 12px;
  color: ${colors.black};
  white-space: nowrap;
  font-weight: 400;
  left: 50%;
  right: auto;

  ${({ thumbPosition }) => {
    if (thumbPosition < 5) {
      return `
        left: 0%;
        transform: translateX(0%);
      `
    }
    if (thumbPosition > 95) {
      return `
        left: 100%;
        transform: translateX(-100%);
      `
    }
    return ''
  }};

  @media (min-width: 769px) {
    font-size: 16px;
    top: -37px;
    left: 50%;
    right: auto;

    ${({ thumbPosition }) => {
      if (thumbPosition < 5) {
        return `
          left: 0%;
          transform: translateX(0%);
        `
      }
      if (thumbPosition > 95) {
        return `
          left: 100%;
          transform: translateX(-100%);
        `
      }
      return ''
    }};
  }
`

export const LabelCnt = styled.div`
  margin-top: 20px;
  margin-bottom: 16px;
  margin-right: auto;

  @media (min-width: 769px) {
    margin-top: 48px;
    margin-bottom: 16px;
    margin-right: auto;
  }

  ${mediaUp('md')} {
    margin-top: 48px;
  }

  html[lang^='ar'] & {
    margin-right: 0;
    margin-left: auto;
  }
`
